export default __webpack_public_path__ + "static/media/Coursel1Bg2.c7dc80fe.jpg";